export default __webpack_public_path__ + "static/media/wallet.196ce26b.svg";